import { CboRecordDto } from '@act/shared/data-transfer-objects';
import type { CboResourceFormValues } from '../forms/cboResourceForm/cboResourceForm.schema';

/**
 * Maps a persisted CBO record into {@link CboResourceFormValues}.
 *
 * @param record - Server CBO DTO.
 * @param needId - Optional need id for the need selector.
 * @returns Values for the shared CBO resource form.
 */
export function mapCboRecordToFormValues(
  record: CboRecordDto,
  needId?: number
): CboResourceFormValues {
  const addressLine =
    record.streetAddress ||
    record.formattedAddress ||
    [record.city, record.state, record.zipcode].filter(Boolean).join(', ');

  return {
    cboRecordId: record.id,
    name: record.name,
    contactName: record.contactName ?? '',
    phoneNumber: record.phoneNumber ?? '',
    websiteUrl: record.websiteUrl ?? '',
    email: record.email ?? '',
    address: addressLine,
    streetAddress: record.streetAddress ?? '',
    city: record.city ?? '',
    state: record.state ?? '',
    zipcode: record.zipcode ?? '',
    userNeedId: needId ?? null,
    googlePlaceId: record.googlePlaceId,
    placeTypes: record.placeTypes ?? [],
    categoryLabel: record.categoryLabel ?? '',
    addressDetails: record.addressDetails ?? '',
    formattedAddress: record.formattedAddress ?? '',
  };
}
